export default __webpack_public_path__ + "static/samokat_product_2-aad2e1cbce61851d459ee5901250508d.png";